export const GET_WALLET_TRANSACTIONS_START =
  'GET_WALLET_TRANSACTIONS_START';
export const GET_WALLET_TRANSACTIONS_ERROR =
  'GET_WALLET_TRANSACTIONS_ERROR';
export const GET_WALLET_TRANSACTIONS_SUCCESS =
  'GET_WALLET_TRANSACTIONS_SUCCESS';
export const CLEAR_ACCOUNT_NUMBER = 'CLEAR_ACCOUNT_NUMBER';
